import SortableTree, {
  addNodeUnderParent,
  removeNodeAtPath,
  changeNodeAtPath,
  getNodeAtPath,
} from "react-sortable-tree";
import shortid from "shortid";

export const initialState = {"treeData":[{"title":"section","subtitle":"section","tag":"section","id":"ukLOH5IeA","expanded":true,"children":[{"title":"nav","subtitle":"nav","tag":"nav","id":"cOVzv_tx0","expanded":true,"children":[{"title":"ul","subtitle":"ul","tag":"ul","id":"oJXesh9-R","expanded":true,"children":[{"title":"li","subtitle":"li","tag":"li","id":"2BJJ-Bc9X","expanded":true,"children":[{"title":"custom html","subtitle":"custom html","tag":"custom html","customHtmlAvailable":true,"childrenLess":true,"id":"DY0ObEyfL"}]},{"title":"li","subtitle":"li","tag":"li","id":"0Ktjug3VD","expanded":true,"children":[{"title":"custom html","subtitle":"custom html","tag":"custom html","customHtmlAvailable":true,"childrenLess":true,"id":"wuICA7AuP"}]},{"title":"li","subtitle":"li","tag":"li","id":"4nOzVEnjl","expanded":true,"children":[{"title":"custom html","subtitle":"custom html","tag":"custom html","customHtmlAvailable":true,"childrenLess":true,"id":"Fqrd_QPLZ"}]}]}]},{"title":"header","subtitle":"header","tag":"header","id":"ElB2Tntnh","expanded":true,"children":[{"title":"h1","subtitle":"h1","tag":"h1","id":"oT5YgiOFb","expanded":true,"children":[{"title":"custom html","subtitle":"custom html","tag":"custom html","customHtmlAvailable":true,"childrenLess":true,"id":"2bOOK8Nb0"}]},{"title":"div","subtitle":"div","tag":"div","id":"-X64IUE28","expanded":true,"children":[{"title":"custom html","subtitle":"custom html","tag":"custom html","customHtmlAvailable":true,"childrenLess":true,"id":"hrluSEiPz"}]}]}]}],"attributes":{"I7kur_eFV":{"classes":[]},"OHgN8hu6I":{"classes":[]},"S4ahehsVA":{"classes":["md:container","lg:container","xl:container"]},"R3sXgcaLj":{"classes":["h-screen","flex","flex-col","bg-purple-500"]},"3S3xNBgYb":{"classes":["flex","justify-around","sm:flex-col","lg:flex-row","xl:flex-row","flex-col","md:flex-row"],"userDefined":{"asdsadasd":"adsadsad","sdfsdf":"sdfsdf","dsfcdf":"sdfsdf"}},"7Eikk37Zr":{"classes":["flex","flex-col","items-center","flex-grow","justify-center"]},"kFw_7kmzY":{"classes":["font-bold","text-6xl"]},"Z91Fub44G":{"classes":["px-8","py-10"]},"NmH3A2Id4":{"classes":["h-screen"]},"nL0gSSJOt":{"classes":["text-white"]},"wxPC7gJC3":{"classes":["text-white","text-2xl"]},"M6RXubBC2":{"classes":["bg-white","rounded-full","px-2","text-lg","border-4"]},"cYYZREVGk":{"classes":["bg-white","rounded-full","px-2","text-lg","border-4"]},"9BFFYSTbS":{"classes":["bg-white","rounded-full","px-2","text-lg","border-4"]},"cyZGDqBw6":{"userDefined":{"src":"https://www.google.com/images/branding/googlelogo/2x/googlelogo_color_272x92dp.png"}},"vSx2pon3_":{"customHtml":"<strong>sdfdsfdsfsdfsd</strong>"},"14RSbQMnU":{"customHtml":"","classes":[]},"cm8th4lI1":{"customHtml":"<p>asdgasdu</p>","classes":[]},"fOpuI_n7D":{"customHtml":""},"3FNHlGse3":{"customHtml":"sdzfsdfsdfsdf"},"cZpoXKqal":{"customHtml":"","classes":[]},"LWNKPqA8f":{"classes":["max-w-screen-xl"]},"XbMh1sHzx":{"customHtml":"","classes":[]},"ukLOH5IeA":{"classes":["h-screen","flex","flex-col","bg-indigo-600"]},"ElB2Tntnh":{"classes":["flex-grow","flex","flex-col","justify-center","text-gray-200"]},"2bOOK8Nb0":{"customHtml":"Welcome to Tailwind Blower"},"oT5YgiOFb":{"classes":["font-bold","text-center","text-6xl"]},"hrluSEiPz":{"customHtml":"A TailwindCSS Framework based playground."},"-X64IUE28":{"classes":["text-center","text-2xl"]},"oJXesh9-R":{"classes":["flex","justify-evenly","font-semibold","text-gray-200","items-center"]},"DY0ObEyfL":{"customHtml":"<a href=\"https://tailwindcss.com/\" target=\"_blank\" > Tailwind CSS Framework ?</a>"},"wuICA7AuP":{"customHtml":"<a href=\"https://www.linkedin.com/in/kumarvikas16/\" target=\"_blank\" >Created by Vikas Kumar</a>"},"cOVzv_tx0":{"classes":["p-4"]},"Fqrd_QPLZ":{"customHtml":""},"2BJJ-Bc9X":{"classes":["border-2","py-2","px-3","rounded-full"]},"0Ktjug3VD":{"classes":["px-3","py-2","border-2","rounded-full"]},"4nOzVEnjl":{"classes":["px-3","py-2","rounded-full"]}},"searchString":"wuICA7AuP","searchFoundCount":null,"selectedNode":{"title":"custom html","subtitle":"custom html","tag":"custom html","customHtmlAvailable":true,"childrenLess":true,"id":"wuICA7AuP"}};

const changeUserDefinedAttributes = (state, action) => {
  const selectedNodeId = state.selectedNode.id;
  const selectedNodeAttributes =
    state.attributes && state.attributes[selectedNodeId];

  const newAttributesForSelectedNode = {
    ...selectedNodeAttributes,
    customHtml: action.payload.customHtml,
  };

  const newAttributes = {
    ...state.attributes,
    [selectedNodeId]: newAttributesForSelectedNode,
  };

  const newState = {
    ...state,
    attributes: newAttributes,
  };

  return newState;
};

const changeActiveClassesForElement = (state, action) => {
  const selectedNodeId = state.selectedNode.id;
  const selectedNodeAttributes =
    state.attributes && state.attributes[selectedNodeId];
  const activeClasses = selectedNodeAttributes?.classes || [];
  const newAttributesForSelectedNode = (() => {
    if (activeClasses && activeClasses.includes(action.payload._class)) {
      return {
        ...selectedNodeAttributes,
        classes: activeClasses.filter(
          (appliedClass) => appliedClass !== action.payload._class
        ),
      };
    }
    return {
      ...selectedNodeAttributes,
      classes: [...activeClasses, action.payload._class],
    };
  })();

  const newAttributes = {
    ...state.attributes,
    [selectedNodeId]: newAttributesForSelectedNode,
  };

  const newState = {
    ...state,
    attributes: newAttributes,
  };

  return newState;
};

export const getNodeKey = ({ treeIndex }) => treeIndex;

export function reducer(state, action) {
  switch (action.type) {
    case "REPLACE_WHOLE_STATE":
      return action.payload.newState;

    case "REPLACE_TREE_DATA":
      return { ...state, treeData: action.payload.newTreeData };

    case "ADD_NODE_UNDER_TREE_DATA":
      return {
        ...state,
        treeData: addNodeUnderParent({
          treeData: state.treeData,
          parentKey: action.payload.path[action.payload.path.length - 1],
          expandParent: true,
          getNodeKey,
          newNode: {
            title: `Container`,
            id: shortid.generate(),
            subtitle: "div",
            tag: "div",
            classes: [],
          },
          addAsFirstChild: true,
        }).treeData,
      };

    case "REMOVE_NODE_UNDER_TREE_DATA_AT_PATH":
      return {
        ...state,
        treeData: removeNodeAtPath({
          treeData: state.treeData,
          path: action.payload.path,
          getNodeKey,
        }),
      };
    case "CHANGE_NODE_CLASS_UNDER_TREE_DATA_AT_PATH":
      return changeActiveClassesForElement(state, action);

    case "REPLACE_ATTRIBUTES_FOR_SELECTED_NODE":
      return changeUserDefinedAttributes(state, action);

    case "CHANGE_SELECTED_NODE_PATH":
      return {
        ...state,
        selectedNode: action.payload
      };

    case "CHANGE_TREE_SEARCH_TERM": {
      if (state.searchString !== action.payload.searchTerm) {
        return {
          ...state,
          searchString: action.payload.searchTerm,
        };
      }
      return state;
    }

    default:
      throw new Error();
  }
}
